export enum BI_SOURCE_PAGE {
  ORDER_SUCCESS = 'order-success',
}
